import { render } from "./LeaderboardsView.vue?vue&type=template&id=2c9eaf4e&scoped=true"
import script from "./LeaderboardsView.vue?vue&type=script&lang=js"
export * from "./LeaderboardsView.vue?vue&type=script&lang=js"

import "./LeaderboardsView.vue?vue&type=style&index=0&id=2c9eaf4e&scoped=true&lang=css"

import exportComponent from "/builds/unifybusiness/pics/games/arcade-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9eaf4e"]])

export default __exports__